import { SectionCard } from "./SectionCard";
import { FooterText } from "./FooterText";

const AccountTermsAndConditions = () => {
  return (
    <div className="container my-4 px-3" style={{ textAlign: "justify" }}>
      <header className="pb-3 mb-4 text-center">
        <h2 className="card-title text-primary fw-bolder">
          TERMS AND CONDITIONS FOR KEGOW
        </h2>
        <p className="text-muted mt-2">
          Read our terms below to learn more about your rights and
          responsibilities as a Kegow user.
        </p>
      </header>

      <div>
        <SectionCard
          title="1. Introduction and Acceptance"
          customContent={
            <div>
              <p className="mb-3">
                Welcome to <b>Kegow</b> App. Please read these Terms of Use
                carefully before using the Kegow App and website ("Platform").
                Users who are under 18 years of age should review these terms
                and conditions with a parent or guardian. Your access to and use
                of the Platform by way of any Device is conditioned on your
                acceptance of and compliance with the provisions of this Terms
                of Use. By your accessing or using the Platform you agree to be
                bound by these Terms of Use as amended at any time and posted on
                the{" "}
                <a
                  href="https://kegow.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="text-decoration-none fw-bolder"
                >
                  Kegow website
                </a>{" "}
                or the app. If you disagree with any part hereof, do not access
                the Platform.
              </p>
              <p className="mb-0">
                This document is a legally binding agreement between you as the
                user(s) of the Sites (referred to as "<b>you</b>", "<b>your</b>"
                or "<b>User</b>" hereinafter) and the Kegow entity listed in
                clause below (referred to as "<b>we</b>", "<b>our</b>" or "
                <b>Kegow</b>" hereinafter).
              </p>
            </div>
          }
        />

        <SectionCard
          title="2. General Use of the App"
          customContent={
            <ul className="mb-0">
              <li className="mb-2">
                You agree to use the platform only for purposes that are
                permitted by (a) this Terms and Conditions of Use Policy, and
                (b) any Applicable law, regulation, or generally accepted
                practices or guidelines in the relevant jurisdictions (including
                any laws regarding the export of data or software).
              </li>
              <li className="mb-2">
                You agree not to access (or attempt to access) Kegow by any
                means other than through the interface that is provide Kegow
                platform through any automated means (including use of scripts
                or web crawlers).
              </li>
              <li className="mb-2">
                You agree that you will not engage in any activity that
                interferes with or disrupts Kegow app or website (or the servers
                and networks which are connected to such App).
              </li>
              <li className="mb-2">
                You agree that you will not reproduce, duplicate, copy,
                republish, upload, post, transmit, distribute, modify, sell,
                trade, or resell Kegow app, or any portion, feature, or content
                thereof, for any purpose.
              </li>
              <li className="mb-2">
                You agree that you are solely responsible for (and that Kegow
                has no responsibility to you or to any third-party for) any
                breach of your obligations under the Terms and Conditions of Use
                and for the consequences (including any loss or damage which
                Kegow may suffer) of any such breach.
              </li>
              <li className="mb-2">
                You must be 18 years or older to use Kegow app unsupervised. If
                you are under the age of 18, you may only use Kegow in
                conjunction with, and under the supervision of, your parents or
                guardians.
              </li>
              <li className="mb-2">
                We reserve the right to modify or discontinue, temporarily or
                permanently, your access to Kegow app, with or without notice.
              </li>
              <li className="mb-0">
                You agree that any task requested outside the platform is at
                your own risk.
              </li>
            </ul>
          }
        />
        <SectionCard
          title="3. Ownership, Copyright and Trademark"
          customContent={
            <div>
              <p className="mb-3">
                All content included on Kegow App, such as trademarks, service
                marks, trade names, text, graphics, logos, icons, button icons,
                images, data compilations, domain names, and software, is the
                property of Kegow or its content suppliers or used with
                permission.
              </p>
              <p className="mb-3">
                The compilation of all content on this site is the exclusive
                property of Kegow and are protected by Nigerian and
                International copyright laws. All software used on this site is
                the property of Kegow and are protected by Nigerian and
                International copyright laws. Nothing on this site should be
                construed as granting any license or right to such content or
                software.
              </p>
            </div>
          }
        />

        <SectionCard
          title="4. Termination"
          customContent={
            <div>
              <p className="mb-3">
                We may terminate or suspend access to our service immediately
                without prior notice or liability, for any reason whatsoever,
                including without limitation if you breach the Terms.
              </p>
              <p className="mb-0">
                All provisions of the Terms which by their nature shall survive
                termination, including, without limitation, ownership
                provisions, warranty disclaimers, indemnity and limitations of
                liability.
              </p>
            </div>
          }
        />

        <SectionCard
          title="5. Site Terms of Use Modifications"
          items={[
            "Kegow may revise these Terms of Use for its app at any time without prior notice.",
            "By using this App, you are agreeing to be bound by the current version of these Terms and Conditions.",
          ]}
        />

        <SectionCard
          title="6. Communications"
          customContent={
            <div>
              <p className="mb-0">
                When You use the App or send emails or other data, information
                or communication to us, You agree and understand that You are
                communicating with Us through electronic records and You consent
                to receive communications via electronic records from Us
                periodically and as and when required. We may communicate with
                you by email or by such other mode of communication, electronic
                or otherwise.
              </p>
            </div>
          }
        />

        <SectionCard
          title="7. Links and Third-Party Websites"
          customContent={
            <div>
              <p className="mb-3">
                We may include links to third party websites at any time.
                However, the existence of a link to another website should not
                be consider as an affiliation or a partnership with a third
                party or viewed as an endorsement of a particular website unless
                explicitly stated otherwise. In the event the user follows a
                link to another website, he or she does so at his or her own
                risk. We accept no responsibility for any content, including,
                but not limited to, information, products and services,
                available on third party websites.
              </p>
              <p className="mb-0">
                Creating a link to this App is strictly forbidden without our
                prior written consent. Furthermore, we reserve the right to
                revoke our consent without notice or justification.
              </p>
            </div>
          }
        />

        <SectionCard
          title="8. Data Protection"
          items={[
            "Any personal information collected in relation to the use of this App will be held and used in accordant with our privacy policy, which is available on our site.",
          ]}
        />

        <SectionCard
          title="9. Indemnity"
          customContent={
            <div>
              <p className="mb-0">
                You agree to indemnify and hold us, our affiliates, officers,
                directors, agents and/or employees, as the case may be, free
                from any claim or demand, including reasonable legal fees,
                related to your breach of these Terms of Use and User Agreement.
              </p>
            </div>
          }
        />

        <SectionCard
          title="10. Severability"
          customContent={
            <div>
              <p className="mb-0">
                If any portion of these terms or conditions is held by any court
                or tribunal to be invalid or unenforceable, either in whole or
                in part, then that part shall be severed from these Terms and
                Conditions of Use and shall not affect the validity or
                enforceability of any other section listed in this document.
              </p>
            </div>
          }
        />

        <SectionCard
          title="11. Miscellaneous Provisions"
          customContent={
            <div>
              <p className="mb-3">
                You agree that all agreements, notices, disclosures and other
                communications that we provide to you electronically satisfy any
                legal requirement that such communications be in writing.
              </p>
              <p className="mb-0">
                Assigning or sub-contracting any of your rights or obligations
                under these Terms and Conditions of Use to any third party is
                prohibited unless agreed upon in writing by the seller. We
                reserve the right to transfer, assign or sub-contract the
                benefit of the whole or part of any rights or obligations under
                these Terms and Conditions of Use to any third party.
              </p>
            </div>
          }
        />

        <SectionCard
          title="12. Governing Law"
          customContent={
            <div>
              <p className="mb-0">
                These Terms and Conditions shall be interpreted and governed by
                the laws in force in the Federal Republic of Nigeria. Subject to
                the Arbitration section below, each party hereby agrees to
                submit to the jurisdiction of the courts of Nigeria and to waive
                any objections based upon venue.
              </p>
            </div>
          }
        />

        <SectionCard
          title="13. Arbitration"
          customContent={
            <div>
              <p className="mb-3">
                Any controversy, claim or dispute arising out of or relating to
                these Terms and Conditions be referred to and finally settled by
                private and confidential binding arbitration before a single
                arbitrator held in Nigeria in English and governed by Nigeria
                law pursuant to the Arbitration and Conciliation Act Cap A18
                Laws of the Federation of Nigeria 2004, as amended, replaced or
                re-enacted from time to time.
              </p>
              <p className="mb-0">
                The arbitrator shall be a person who is legally trained and who
                has experience in the information technology field in Nigeria
                and is independent of either party. Notwithstanding the
                foregoing, the Site reserves the right to pursue the protection
                of intellectual property rights and confidential information
                through injunctive or other equitable relief through the courts.
              </p>
            </div>
          }
        />

        <SectionCard
          title="14. Account Closure"
          customContent={
            <div>
              <p className="mb-3">
                The Central Bank of Nigeria Regulatory Framework for Mobile
                Money Services in Nigeria, Section 17(d), states that: "The
                electronic summary of transactions and the electronic receipt
                should be securely logged, and the log maintained online for a
                minimum period of three (3) months and subsequently archived for
                a minimum period of seven (7) years".
              </p>
              <p className="mb-0">
                Therefore, deletion of records will be done according to the CBN
                regulatory framework. In accordance with this regulation,
                records will be deleted accordingly. While the wallet will be
                deactivated, the records will be retained but will only be
                accessible through legal means.
              </p>
            </div>
          }
        />

        <SectionCard
          title="Privacy Policy"
          customContent={
            <div>
              <div className="text-center mb-4">
                <b>
                  <p>
                    I HEREBY ACKNOWLEDGE THAT I HAVE READ AND UNDERSTAND THE
                    FOREGOING TERMS OF SERVICE AND GENERAL GUIDELINES THAT MY
                    USE OF THE SERVICE IS AN ACKNOWLEDGMENT OF MY AGREEMENT TO
                    BE BOUND BY THE TERMS AND CONDITIONS OF THIS PLATFORM.
                  </p>
                </b>
              </div>

              <p className="mb-3">
                Kegow recognizes the importance of protecting the privacy of all
                information provided by users on www.kegow.com This statement is
                meant to affirm our utmost respect for your rights to privacy.
              </p>

              <p className="mb-3">
                This Privacy Policy describes the User's privacy rights
                regarding Kegow App usage and transactions where applicable. It
                applies to our App and all linked sites, applications and tools
                irrespective of medium through which you access them.
              </p>

              <p className="mb-3">
                The User acknowledges that Kegow may verify their identity
                information through publicly and/or restricted government
                databases in order to comply with regulatory requirements.
              </p>

              <p className="mb-3">
                The User accept that Kegow shall not be liable for any loss,
                claim, action, expense; damage or injury suffered or sustained
                by the User whatsoever and howsoever pursuant to entering into
                this Agreement or as a result of the User's negligence with
                his/her information.
              </p>

              <p className="mb-3">
                You acknowledge that by your use of the App, we shall be privy
                to and store some of your personal information (full name,
                mobile phone number, email address, contact address, gender,
                place of birth, date of birth, next of kin and passport
                photograph) where applicable.
              </p>

              <p className="mb-3">
                We shall use our best endeavors to ensure that your personal
                information is secure on our systems.
              </p>

              <p className="mb-3">
                Kegow's employees who handle any personal information are under
                an obligation to treat it confidentially and may not disclose it
                to un-authorised third parties.
              </p>

              <p className="mb-3">
                If we need the User's information for any other reason such as
                marketing, we will expressly ask or provide the User with an
                option to decline.
              </p>

              <p className="mb-3">
                After the User has given His/her consent, He or She may for any
                reason change their mind; they are allowed to withdraw their
                consent for the use of their information.
              </p>

              <p className="mb-2">We may use your personal information for:</p>
              <ol type="i" className="mb-3">
                <li>
                  Providing you the service, processing transactions, and
                  sending you related information;
                </li>
                <li>Providing, maintaining, and improving our services;</li>
                <li>Sending support and administrative messages to you;</li>
                <li>Responding to your inquiries and requests;</li>
                <li>Providing customer service;</li>
                <li>
                  Updating you on products, services, promotions, rewards, and
                  events offered by us and third parties; and
                </li>
                <li>
                  A better understanding of your needs by combining it with
                  information collected from others with the objective of
                  improving on our service delivery.
                </li>
              </ol>

              <p className="mb-2">
                We may disclose any information we collect about you to third
                parties as set forth below:
              </p>
              <ol type="i" className="mb-3">
                <li>To regulatory bodies;</li>

                <li>To financial institutions;</li>
                <li>
                  To companies, such as email service providers that perform
                  marketing services on our behalf;
                </li>
                <li>
                  To third parties to enable us provide Service to you; and
                </li>
                <li>
                  If required to be disclosed under applicable law, or stock
                  exchange regulation or by a government order, decree,
                  regulation or rule or by a court order.
                </li>
              </ol>

              <p className="mb-0">
                You hereby consent to the processing and transfer of your
                information during and after the use of the Platform.
              </p>
            </div>
          }
        />

        <FooterText
          supportText="For inquiries or customer support, please contact Kegow customer
            service through the official app channels."
          termsText="These Terms and Conditions constitute the entire agreement between
              you and Kegow. Continued use of the platform indicates acceptance
              of all terms and conditions outlined herein. Kegow reserves the
              right to modify these terms at any time, with changes communicated
              through the platform."
        />
      </div>
    </div>
  );
};

export default AccountTermsAndConditions;
